export default () => {
    const getAbortable = () => new AbortController();

    const abortable = ref<AbortController>(getAbortable());

    const abort = () => {
        abortable.value?.abort();
        abortable.value = getAbortable();
    };

    const signal = computed(() => abortable.value.signal);

    const fetching = <TRequest extends Parameters<typeof fetch>[0], TInit extends Parameters<typeof fetch>[1]>(input: TRequest, init: TInit) => fetch(input, { ...init, signal: signal.value });

    return { abortable, abort, signal, fetching };
};
